var _defs, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.19 67.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:#fff;stroke:#1d1d1b;}.cls-1{stroke-width:0.25px;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{stroke-width:0.5px;}.cls-3{stroke-width:0.5px;}.cls-4{stroke-miterlimit:4.01;stroke-width:0.5px;}.cls-5{stroke-width:0.5px;}.cls-6{stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3062-6-3-9",
    className: "cls-1",
    d: "M43.31,18.35l-8.57,6.33C29.38,19.39,23.16-.56,21,4.18c-1,2.37-3.47,16.13-2.52,18.51l6.34,9L4.28,25.37c-4.75,1.9,2.8,11.55,7.8,13.9C13,41.64,22.29,40,24.9,41l-9.35,6.92L9.38,62.28C18.51,61,27,52.08,32.68,52.08c3.41.29,4.43,19.88,9.84,18.13L46,56,42.24,39.7c1.9,4.74,8.3,6.07,13.9,7.92,2.37-.95,14,7.12,14.57,2l-10.8-12.7L46.3,29.16C51,31.3,56.45,12.2,58.59,7.46,59.53,5.08,43.31,18.35,43.31,18.35Z",
    transform: "translate(-2.65 -3.33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path3062-6-3-9-2",
    className: "cls-2",
    d: "M31,11.25A36.52,36.52,0,0,0,29.55,24.4l.3,6-9.08-.28c-5.25.45-11.53,6-9.49,8.3,1.06,1.07,16.2,2.06,17.72,2l-4.1,7.43,4.22,9.65c-1.26,15.66,8.47-6.69,10.06-11.22,2.16-3-1.31-4.2,7.12,2.37H61.57L46.34,35.47c2.09,2.38,10-11.86,11.3-15.32.92-2-15.21,7.8-15.21,7.8L36.5,20.22C35.24,15.5,31.82,8.93,31,11.25Z",
    transform: "translate(-2.65 -3.33)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 40.64,
    cy: 25.55,
    rx: 11.01,
    ry: 3.18,
    transform: "translate(-3.02 47.16) rotate(-63.46)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 29.39,
    cy: 30.45,
    rx: 3.19,
    ry: 8.48,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -14.3, 37.42)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 31.68,
    cy: 41.87,
    rx: 8.45,
    ry: 3.18,
    transform: "translate(-23.07 45.04) rotate(-60)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 44.1,
    cy: 39.04,
    rx: 4.86,
    ry: 8.45,
    transform: "translate(-15.39 51.15) rotate(-56.71)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVxt);
export default __webpack_public_path__ + "static/media/växt.dd1f4dc4a96613e0985d2128d4542bb5.svg";
export { ForwardRef as ReactComponent };